// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"1f007319","585":"c93a4eda"}[chunkId] + ".chunk.js";
};